import React, { useState } from 'react';
import { XIcon, CheckIcon, GlobeIcon } from 'lucide-react';
interface LanguageBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  currentLanguage: string;
  onLanguageChange: (language: string) => void;
}
export function LanguageBottomSheet({
  isOpen,
  onClose,
  currentLanguage,
  onLanguageChange
}: LanguageBottomSheetProps) {
  const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);
  const languages = [{
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧'
  }, {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'Arabic',
    flag: '🇸🇦'
  }];
  const handleApply = () => {
    onLanguageChange(selectedLanguage);
    onClose();
  };
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] transition-opacity duration-300" onClick={onClose} style={{
      backdropFilter: 'blur(4px)'
    }} data-id="element-3689" data-mp="bw3q35cjkxj9" />
      {/* Bottom Sheet */}
      <div className="fixed bottom-0 left-0 right-0 z-[70] bg-white rounded-t-3xl shadow-2xl transition-transform duration-300 ease-out" style={{
      maxHeight: '90vh',
      height: 'auto',
      maxWidth: '640px',
      margin: '0 auto',
      transform: isOpen ? 'translateY(0)' : 'translateY(100%)'
    }} data-id="element-3690" data-mp="3izh4r5add7t0">
        {/* Drag Handle */}
        <div className="flex justify-center pt-3 pb-2" data-id="element-3691" data-mp="3040j0dxoj47m">
          <div className="w-12 h-1.5 bg-gray-300 rounded-full" data-id="element-3692" data-mp="2vbph55jdp8cf" />
        </div>
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-3xl z-10" data-id="element-3693" data-mp="2qc4k50nrra2c">
          <div className="flex items-center" data-id="element-3694" data-mp="2lfmi48jtpptp">
            <GlobeIcon className="w-5 h-5 text-[#1E2B55] mr-2" data-id="element-3695" data-mp="2hcpta03owxhb" />
            <h2 className="text-lg font-bold text-gray-900" data-id="element-3696" data-mp="2healvk6g26cj">Language</h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-3697" data-mp="2cdwoqx6dsgta">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-3698" data-mp="26qul71m3ah8k" />
          </button>
        </div>
        {/* Quick Toggle - Hidden on mobile, visible on desktop */}
        <div className="hidden md:block px-6 py-4 border-b border-gray-100" data-id="element-3699" data-mp="1sswac66z92xt">
          <div className="flex gap-3" data-id="element-3700" data-mp="1xrhbc7u1zqnb">
            {languages.map(lang => <button key={lang.code} onClick={() => setSelectedLanguage(lang.code)} className={`flex-1 py-3 px-4 rounded-lg font-medium transition-all ${selectedLanguage === lang.code ? 'bg-[#1E2B55] text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-3701" data-mp="2lfqoymh4583d">
                <span className="mr-2" data-id="element-3702" data-mp="2gnfpfkqabobc">{lang.flag}</span>
                {lang.nativeName}
              </button>)}
          </div>
        </div>
        {/* Language List */}
        <div className="overflow-y-auto px-6 py-4" style={{
        maxHeight: 'calc(90vh - 240px)'
      }} data-id="element-3703" data-mp="396cwmcn7gqcu">
          <div className="space-y-2" data-id="element-3704" data-mp="sriyyhkv2jna">
            {languages.map(lang => <button key={lang.code} onClick={() => setSelectedLanguage(lang.code)} className={`w-full flex items-center justify-between p-4 rounded-lg transition-all ${selectedLanguage === lang.code ? 'bg-blue-50 border-2 border-[#1E2B55]' : 'bg-white border-2 border-gray-200 hover:border-gray-300'}`} data-id="element-3705" data-mp="spexs7ecjyqp">
                <div className="flex items-center" data-id="element-3706" data-mp="9tyj2002qvet">
                  <span className="text-2xl mr-3" data-id="element-3707" data-mp="ns6eu4ldjqoe">{lang.flag}</span>
                  <div className="text-left" data-id="element-3708" data-mp="nqbr6iipxkgm">
                    <div className="font-medium text-gray-900" data-id="element-3709" data-mp="istpnd7167in">{lang.name}</div>
                    <div className="text-sm text-gray-500" data-id="element-3710" data-mp="1z7bibatbxt92">
                      {lang.nativeName}
                    </div>
                  </div>
                </div>
                {selectedLanguage === lang.code && <CheckIcon className="w-5 h-5 text-[#1E2B55]" data-id="element-3711" data-mp="2pjgn7bkb0k7x" />}
              </button>)}
          </div>
        </div>
        {/* Footer */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4" data-id="element-3712" data-mp="2zguq08db1ahr">
          <button onClick={handleApply} className="w-full py-3 px-6 bg-[#1E2B55] text-white font-bold rounded-lg hover:bg-[#162041] transition-colors shadow-md" data-id="element-3713" data-mp="2zj7el4dkij3s">
            Apply Language
          </button>
        </div>
      </div>
    </>;
}